<template>
  <div>
    <a-spin :spinning="spinning">
      <a-card style="margin-top: 30px">
        <a-row type="flex">
          <a-col :span="4">
            <span>
              <span class="title">{{ $t('message.customGroup.title3') }}：</span>
              <span class="value">{{
                showThousandNum(this.peopleInfo.user_count)
              }}</span>
            </span>
          </a-col>
          <a-col :span="4">
            <div v-if="editGroup">
              <span>
                <span class="title">{{ $t('message.customGroup.title4') }}：</span>
                <span class="value">{{ this.peopleInfo.group_name }}</span>
              </span>
            </div>
          </a-col>
          <a-col :span="4">
            <div v-if="editGroup">
              <span>
                <span class="title">{{ $t('message.customGroup.title5') }}：</span>
                <span class="value">{{ this.peopleInfo.group_id }}</span>
              </span>
            </div>
          </a-col>
          <a-col :span="12">
            <div style="float: right">
              <a-button  :size="$globalSize"  type="primary" @click="searchPeople">
                {{ $t('message.customGroup.title6') }}
              </a-button>
              <a-button  :size="$globalSize" 
                type="primary"
                style="margin-left: 20px"
                @click="savePeople"
                >{{ $t('message.customGroup.title7') }}</a-button
              >
            </div>
          </a-col>
        </a-row>

        <a-card style="margin-top: 20px">
          <a-form-model ref="ruleForm" :model="form" :rules="rules">
            <a-form-model-item prop="where">
              <a-input :size="$globalSize"
                v-model="form.where"
                :placeholder="$t('message.customGroup.title8')"
                type="textarea"
                :rows="10"
              />
            </a-form-model-item>
          </a-form-model>
        </a-card>
      </a-card>
      <a-modal
        v-model="saveModal"
        :maskClosable="false"
        :title="$t('message.customGroup.SaveAudience')"
        width="680px"
      >
        <template slot="footer">
          <a-button  :size="$globalSize"  key="back" @click="closeSaveModal"> {{ $t('message.customGroup.Cancel') }} </a-button>
          <a-button  :size="$globalSize" 
            key="submit"
            type="primary"
            :loading="loadingSpin"
            @click="saveBtn"
          >
            {{ $t('message.customGroup.Save') }}
          </a-button>
        </template>
        <a-spin :spinning="spinningBtn">
          <a-form-model
            ref="saveForm"
            :rules="saveFormRules"
            :model="saveForm"
            :label-col="{ span: 7 }"
            :wrapper-col="{ span: 14 }"
          >
            <a-form-model-item :label="$t('message.customGroup.UserCount')">
              <span :loading="loadingSpin" style="font-weight: bold">{{
                showThousandNum(this.peopleInfo.user_count)
              }}</span
              > {{ $t('message.customGroup.people') }}
            </a-form-model-item>
            <a-form-model-item :label="$t('message.customGroup.CalculationType')" prop="calc_type">
              <a-radio-group :size="$globalSize" v-model="saveForm.calc_type" :disabled="reload">
                <a-tooltip placement="top">
                  <template slot="title">
                    <span>{{ $t('message.customGroup.DynamicTip') }}</span>
                  </template>
                  <a-radio :value="1">{{ $t('message.customGroup.Dynamic') }} </a-radio>
                </a-tooltip>
                <a-tooltip placement="top">
                  <template slot="title">
                    <span
                      >{{ $t('message.customGroup.StaticTip') }}</span
                    >
                  </template>
                  <a-radio :value="2"> {{ $t('message.customGroup.Static') }}</a-radio>
                </a-tooltip>
              </a-radio-group>
            </a-form-model-item>
            <a-form-model-item :label="$t('message.customGroup.title4')" prop="group_name">
              <a-input :size="$globalSize" v-model.trim="saveForm.group_name" :maxLength="64" :disabled="reload" />
            </a-form-model-item>
            <a-form-model-item :label="$t('message.customGroup.AudienceIDGenerate')" prop="autoid">
              <a-radio-group :size="$globalSize"
                v-model="saveForm.autoid"
                :disabled="autoidDisable"
              >
                <a-radio :value="0">{{ $t('message.customGroup.Manually') }}</a-radio>
                <a-radio :value="1">{{ $t('message.customGroup.Autogen') }}</a-radio>
              </a-radio-group>
            </a-form-model-item>
            <a-form-model-item
              :label="$t('message.customGroup.title5')"
              prop="group_id"
              v-if="saveForm.autoid === 0"
            >
              <a-input-number :size="$globalSize"
                style="width: 100%"
                :min="1"
                :max="9007199254740992"
                :step="1"
                v-model="saveForm.group_id"
                :disabled="reload || people_id_reload"
              />
            </a-form-model-item>
            <a-row
              v-if="saveForm.autoid === 0"
              style="
                margin-top: -20px;
                margin-bottom: 20px;
                color: red;
                font-size: 12px;
              "
            >
              <a-col :span="6"></a-col>
              <a-col :span="12">（{{ $t('message.customGroup.AudienceIDRange')}}：1~9,007,199,254,740,992）</a-col>
            </a-row>
          </a-form-model>
        </a-spin>
      </a-modal>
    </a-spin>
  </div>
</template>
<script>
import utils from "@/utils";
// import queryUserGroupInfoService from "@/interface/pages/UserGroup/customGroup";
import loadCustomSizeService from "@/interface/pages/UserGroup/customGroup";
import customGroupService from "@/interface/pages/UserGroup/customGroup";
export default {
  name: "CustomUserGroup",
  data() {
    return {
      spinning: false,
      editGroup: false,
      form: {
        where: "",
      },
      rules: {
        where: [{ required: true, message: this.$t('message.customGroup.title8'), trigger: "change" }],
      },
      peopleInfo: {},
      saveModal: false,
      saveForm: {
        group_id: void 0,
        group_name: void 0,
        upd: void 0, // 要判断下是从哪来的 菜单点击进来的 就是新增 0是新增 1是更新
        autoid: void 0, // autoid 如果选自动生成也要传
        calc_type: void 0, // 动态1 | 静态2
        where: void 0,
      },
      spinningBtn: false,
      people_id_reload: false,
      autoidDisable: false,
      loadingSpin: false,
      reload: false,
      saveFormRules: {
        group_name: [
          { required: true, message: ()=> this.$t('message.customGroup.FillinAudienceName'), trigger: "blur" },
        ],
        calc_type: [
          { required: true, message: ()=> this.$t('message.customGroup.SelectCalculationType'), trigger: "blur" },
        ],
        autoid: [
          { required: true, message: ()=> this.$t('message.customGroup.SelectAudienceIDGenerationMethod'), trigger: "blur" },
        ],
        group_id: [
          { required: true, message: ()=> this.$t('message.customGroup.FillintheAudienceID'), trigger: "blur" },
        ],
      },
    };
  },
  mounted() {
    let params = this.$route.params;
    if (params.group_id && params.group_name) {
      this.editGroup = true;
      this.saveForm = this.peopleInfo = params;
      this.form.where = params.where;
      this.saveForm.autoid = 0;
      this.saveForm.upd = 1
      this.autoidDisable = true;
      this.reload = true
      this.people_id_reload = true;
    } else {
      this.editGroup = false;
      this.people_id_reload = false;
      this.saveForm.autoid = 1;
      this.saveForm.upd = 0
      this.autoidDisable = false;
    }
    // this.saveForm.group_name = this.$route.params.userGroupName;
  },
  methods: {
    closeSaveModal() {
      this.$refs.saveForm.resetFields();
      this.saveModal = false;
    },
    searchPeople() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loadCustomSize();
        } else {
          return false;
        }
      });
    },
    savePeople() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loadCustomSize();
        //   this.spinningBtn = true;
          this.saveModal = true
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    saveBtn() {
      this.$refs.saveForm.validate((valid) => {
        if (valid) {
            this.addCustomGroup()
        } else {
          return false;
        }
      });
    },
    // queryUserGroupInfo() {
    //   this.spinning = true;
    //   let body = {
    //      group_id: this.peopleInfo.group_id
    //   };
    //   queryUserGroupInfoService
    //     .queryUserGroupInfo(this, { params: body })
    //     .then((response) => {
    //       let res = response.data;
    //       console.log(res);
    //       if (res.code == 200) {

    //         setTimeout(() => {
    //           this.spinning = false;
    //           this.$message.success(res.message);
    //         }, 800);
    //       } else {
    //         this.$message.error(res.message);
    //       }
    //     })
    //     .catch((error) => {
    //       console.log("查询失败！" + error);
    //     });
    // },
    loadCustomSize() {
      this.spinning = true;
      let body = this.form;
      loadCustomSizeService
        .loadCustomSize(this, { data: body })
        .then(
          function (response) {
            let res = response.data;
            if (res.code == "200") {
              this.peopleInfo.user_count = res.data;
              this.$message.success(res.message);
            } else {
              this.$message.error(res.message);
            }
          }.bind(this)
        )
        .catch((response) => {
          console.log(response);
        })
        .finally(() => {
          this.spinning = false;
        });
    },
    addCustomGroup() {
      this.loadingSpin = true
      this.spinningBtn = true;
      // if(!this.editGroup) {
      //     this.saveForm.where = this.form.where
      // }
      this.saveForm.where = this.form.where
      let body = this.saveForm;
      customGroupService
        .addCustomGroup(this, { data: body })
        .then(
          function (response) {
            let res = response.data;
            if (res.code == "200") {
                this.$message.success("保存人群成功!");
                this.saveModal = false
            }else {
                this.$message.error(res.message);
            }
          }.bind(this)
        )
        .catch((response) => {
          console.log(response);
        })
        .finally(() => {
          this.spinningBtn = false;
          this.loadingSpin = false
        });
    },
    showThousandNum(value) {
      return utils.showThousandNumber(value);
    },
  },
};
</script>
<style scoped>
.title {
  font-weight: 600;
}
.value {
  padding-left: 6px;
}
</style>